<script>
    import { onDestroy } from 'svelte';

    import AddExpenseModal from './AddExpenseModal/AddExpenseModal.svelte';
    import AddExpenseBtn from './AddExpenseBtn.svelte';
    import Header from './Header.svelte';
    import List from './List/List.svelte';
    import Counter from './Counter.svelte';
    import SignIn from './Auth/Signin.svelte';
    import SignUp from './Auth/Signup.svelte';

    // Store
    import {UserStore} from '../store';

    // export let currentList;
    export let signinVisibility = true;
    let authStatus;
    let selectedTask;
    
    const unsubUserStore = UserStore.subscribe(data => {
        authStatus = data.authStatus;
    });


    const setSelectedTask = (task) => {
        if(task) {
            selectedTask = task;
        } else {
            selectedTask = undefined;
        }
    };

    const toggleAuthForm = (e) => {
        signinVisibility = !signinVisibility
    };

    // Lifecycle Hooks

    onDestroy(() => {
        unsubUserStore();
    });
</script>
<main class="container h-100 position-relative p-4 bg-secondary">

    {#if !authStatus} 
    
        <!-- Heading -->
        <Header />

        <div class="row">
            <div class="btn-group form-signin" role="group" aria-label="Basic example">
                <button type="button" class="btn btn-light btn-lg" class:active={signinVisibility} on:click={toggleAuthForm}>Sign In</button>
                <button type="button" class="btn btn-light btn-lg" class:active={!signinVisibility} on:click={toggleAuthForm}>Sign Up</button>
            </div>
        </div>

        {#if signinVisibility}

            <SignIn />

        {:else}

            <SignUp />

        {/if}


    {:else if authStatus === 'loading'}

        <p class="display-1 text-center mt-5 text-warning">Loading...</p>
    
    {:else}

        <!-- Heading -->
        <Header />

        <div class="row">

            <div class="col-12 col-md-4 counters-container">
                <!-- Counters -->
                <Counter />
            </div>

            <div class="col-12 col-md-8 lists-container my-4">
                <!-- List -->
                <List />
            </div>

        </div>


        <!-- Add Expense btn -->
        <AddExpenseBtn on:click={setSelectedTask} />


        <!-- Modal -->
        <AddExpenseModal {selectedTask} {setSelectedTask} />
    {/if}

</main>